import { Button } from '@mui/material';
import { useState } from 'react';
import { UploadFileOutlined } from '@mui/icons-material';
import { LoadingSection } from '../../common/LoadingSection';
import { goApi } from '../../services';

export const uploadFile = (file: File, testId: string | number) => {
    return goApi.upload(`/tests/${testId}/extract-doc`, file);
};
const BulkQuestionsViaDocInput = (props: any = {}) => {
    const [loading, setLoading] = useState(false);
    const [docFile, setDocFile] = useState<any>(null);
    return (
        <div style={{ position: 'relative' }}>
            {loading ? (
                <LoadingSection />
            ) : (
                <>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        {docFile ? (
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    marginBottom: '15px',
                                }}
                            >
                                <UploadFileOutlined />
                                <Button
                                    onClick={async () => {
                                        try {
                                            setLoading(true);

                                            const res: any = await uploadFile(docFile, props.testId);

                                            props?.setQuestionsList(res?.data?.questions);

                                        } catch (err) {
                                            console.error(err);
                                            alert('Upload failed.');
                                        }

                                        setLoading(false);
                                    }}                                >
                                    Upload Doc File
                                </Button>
                            </div>
                        ) : (
                            <Button disabled={loading}>
                                Add Word file
                                <input
                                    accept=".doc,.docx"
                                    style={{
                                        position: 'absolute',
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        top: 0,
                                        opacity: 0,
                                    }}
                                    multiple={false}
                                    onChange={e => {
                                        const file = e.target.files?.[0];
                                        setDocFile(file);
                                    }}
                                    type="file"
                                />
                            </Button>
                        )}
                    </div>
                </>
            )}
        </div>
    );
};
export default BulkQuestionsViaDocInput;
